import { Collapse } from '@mui/material';
import { styled } from '@mui/material/styles';

const PeekCollapse = styled(Collapse)(({ theme }) => ({}));

export { PeekCollapse, PeekCollapse as default };
